// vendor modules
import { connect } from "react-redux"

// components
import { ActionButton } from "search-new/components/FilterableListView/ActionButton"

const mapStateToProps = (state, props) => ({})

export default connect(mapStateToProps, {})(ActionButton)
